import { assign, find } from 'lodash'

import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './UsersTypes'

// initial state
function initialState() {
  return {
    items: [],
    editedItem: null,
    loading: false,
  }
} // :user="editedItem" @input="save($event)" @cancel="editedItem = null"

// getters
const getters = {

}

// mutations
const mutations = {
  [mutationTypes.SET_USERS](state, items) {
    state.items = items
  },

  [mutationTypes.SET_EDITED_USER](state, user) {
    // update the user in the current users list with the new properties - replacing would destroy reactivity!
    state.editedItem = user
  },

  [mutationTypes.SET_USER](state, user) {
    // update the user in the current users list with the new properties - replacing would destroy reactivity!
    assign(find(state.items, { id: user.id }), user)
  },

  [mutationTypes.SET_LOADING](state, value) {
    state.loading = value
  },
}

const actions = {
  [actionTypes.FETCH_USERS]({ state, commit }) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.get('users?sort=lastname,asc').then(({ data: { content } }) => {
      commit(mutationTypes.SET_USERS, content)
      commit(mutationTypes.SET_LOADING, false)
      return state
    })
  },

  [actionTypes.DELETE_USER]({ commit, dispatch }, user) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.delete(`users/${user.id}`).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      return dispatch(actionTypes.FETCH_USERS)
    })
  },

  [actionTypes.UPDATE_USER]({ commit, state }, user) {
    commit(mutationTypes.SET_LOADING, true)
    const transformedUser = Object.assign({}, user)
    transformedUser.authorities = user.authorities.map(authority => authority.id)

    return HTTP.patch(`users/${user.id}`, transformedUser).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_USER, null)
      commit(mutationTypes.SET_USER, user)
      return state
    })
  },

  [actionTypes.INVITE_USER]({ commit, dispatch }, user) {
    commit(mutationTypes.SET_LOADING, true)
    const transformedUser = Object.assign({}, user)
    transformedUser.authorities = user.authorities.map(authority => authority.id)
    return HTTP.post('users/invite', transformedUser).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_USER, null)
    })
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Users.js